import { Image } from '@/atoms/Image'
import { useTranslate } from '@/utils/translate/translate-client'
import { DavidButton } from './DavidButton'

export function InspireGenSection() {
  const { t } = useTranslate('pif')

  return (
    <section className="relative w-full px-[16px] py-[88px] md:px-[64px] md:py-[200px]">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[#faf0e7]" />
        <Image
          alt=""
          className="object-cover opacity-[0.55] mix-blend-color-burn"
          src="/v1760914561/theatrical/david/dirt-texture-on-white-01"
          fill
          sizes="100vw"
          loading="lazy"
        />
      </div>

      <div className="relative mx-auto flex w-full max-w-[1440px] shrink-0 flex-col content-stretch items-center gap-[40px] md:flex-row md:gap-[64px]">
        {/* Content */}
        <div className="relative order-2 w-full shrink-0 md:order-1 md:w-1/2 md:flex-[1_0_0]">
          <div className="flex size-full flex-col justify-center">
            <div className="relative box-border flex w-full flex-col content-stretch items-start justify-center gap-[32px] p-0 md:gap-[40px]">
              {/* Copy */}
              <div className="relative flex w-full shrink-0 flex-col content-stretch items-start gap-[12px] not-italic">
                <p className="font-angel-royal relative w-full shrink-0 text-[48px] lowercase not-italic leading-[40px] text-[#141447] md:text-[56px] md:leading-[48px]">
                  {t('davidInspireGenTitle', 'Inspire a Generation of Children')}
                </p>
                <p className="font-whitney-medium md:font-whitney-medium relative w-full shrink-0 text-[16px] not-italic leading-[28px] text-[#141447] md:text-[18px] md:leading-[30px]">
                  {t(
                    'davidInspireGenDescription',
                    'Help fill theaters with laughter, awe, and inspiration. When you Pay it Forward, you give kids the chance to experience DAVID—and discover a hero worth believing in.',
                  )}
                </p>
              </div>

              {/* Buttons */}
              <div className="relative flex w-full shrink-0 flex-col content-stretch items-start gap-[8px] md:w-auto md:flex-row">
                <DavidButton variant="dark" openPifOverlay className="w-full md:w-auto">
                  {t('payItForward', 'Pay it Forward')}
                </DavidButton>
                <DavidButton variant="orange" href="/tickets/david" className="w-full md:w-auto">
                  {t('getShowtimes', 'Get Showtimes')}
                </DavidButton>
              </div>
            </div>
          </div>
        </div>

        {/* Kid Image with Badge */}
        <div className="relative order-1 w-full shrink-0 md:order-2 md:w-1/2 md:flex-[1_0_0]">
          <div className="aspect-square md:aspect-auto relative flex min-h-[370px] w-full items-end justify-center gap-[8px] rounded-[24px] px-[32px] py-[16px] md:min-h-[600px] md:p-[32px]">
            <Image
              alt="Children holding thank you sign"
              className="rounded-[24px] object-cover"
              src="/v1760542668/theatrical/david/caleb-kylee-w-thank-you-01.png"
              fill
              sizes="(max-width: 768px) 100vw, 50vw"
            />
            {/* Pill Badge */}
            <div className="relative z-10 flex shrink-0 items-center justify-center gap-[4px] rounded-[100px] bg-white px-[16px] py-[8px] md:px-[24px] md:py-[10px]">
              <div
                aria-hidden="true"
                className="pointer-events-none absolute inset-[-3px] rounded-[103px] border-[3px] border-solid border-[#f9b74b]"
              />
              <div className="relative size-[18px] shrink-0">
                <Image
                  alt=""
                  className="block"
                  src="/v1761066641/theatrical/david/icon-gift.svg"
                  width={18}
                  height={18}
                />
              </div>
              <div className="font-whitney-medium relative flex shrink-0 flex-col justify-center overflow-hidden text-ellipsis text-nowrap text-center text-[14px] not-italic leading-[0] text-[#411e09] md:text-[16px]">
                <p className="overflow-hidden text-ellipsis whitespace-pre leading-[18px] md:leading-[20px]">
                  {t('davidGiftedBy', 'Gifted by Chris W. in Idaho')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
